import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import DigitalMarketingTrivandrum from "../components/blogs/DigitalMarketingTrivandrum";

const DigitalMarketingAgencyTrivandrum = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.search) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Digital Marketing Company in Trivandrum | SMS ZOO ZOO</title>
        <meta
          name="description"
          content="SMS ZOO ZOO is a results-focused digital marketing company in Trivandrum helping brands improve visibility, leads, and online performance."
        />

        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.smszoozoo.com/digital-marketing-agency-trivandrum"
        />
      </Helmet>

      <Navbar />
      <DigitalMarketingTrivandrum />
      <Footer />
    </>
  );
};

export default DigitalMarketingAgencyTrivandrum;
